var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dots"},[_c('div',{style:(`background-color: ${_vm.color}`)}),_vm._v(" "),_c('div',{style:(`background-color: ${_vm.color}`)}),_vm._v(" "),_c('div',{style:(`background-color: ${_vm.color}`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }